import React, {ReactElement} from "react";
import {Button} from "@mui/material";
import {PAGE_FRAGMENT_WIDTH, PD_SM, PD_XLG, PD_XLG2} from "@/shared/dimens";
import {LabelerTaskSelectFragment} from "./LabelerTaskSelect";
import {StyledBoxColumn} from "@/shared/StyledComponents";
import {LabelerTask} from "@/fyneai-shared/types";
import {ArrowForwardOutlined} from "@mui/icons-material";
import {BaseApp, DIALOG_FLAG_SHOW_CLOSE, DIALOG_FLAG_SHOW_DIALOG_FULLSCREEN} from "@/shared/BaseApp";
import {WorkbenchFragment} from "@/app-modules/labeler/workbench/WorkbenchFragment";
import {PathProps} from "@/shared";
import {TaskDoneHelper} from "../../app-modules/labeler/datasets/tasks/TaskDoneHelper";

export function LabelerTaskSelectView({path, tasks, selectedTask, setSelectedTask}: {
  path: PathProps,
  tasks: LabelerTask[],
  selectedTask: LabelerTask,
  setSelectedTask: (task: LabelerTask) => void
}): ReactElement {
  return <StyledBoxColumn style={{width: "100%", maxWidth: PAGE_FRAGMENT_WIDTH}}>
    <LabelerTaskSelectFragment
      style={{width: "100%"}}
      tasks={tasks}
      selectedTask={selectedTask}
      setSelectedTask={(task) => {
        if (task) {
          setSelectedTask(task);
        }
      }}
    />
    <div style={{padding: PD_SM, width: "100%"}}>
      <Button
        disabled={!selectedTask}
        onClick={() => {
          const id = BaseApp.CONTEXT.showDialog({flags: DIALOG_FLAG_SHOW_DIALOG_FULLSCREEN | DIALOG_FLAG_SHOW_CLOSE}, () =>
            <div style={{display: "flex", flexDirection: "column", width: "100dvw", height: "100dvh"}}>
              <WorkbenchFragment
                showNavigation={true}
                path={path}
                task={selectedTask}
                onFinish={() => {
                  BaseApp.CONTEXT.hideDialog(id);
                  setTimeout(() => TaskDoneHelper.showDoneDialog(), 100);
                }}/>
            </div>);
        }}
        variant={"contained"}
        color={"secondary"}
        endIcon={<ArrowForwardOutlined/>}
        style={{width: "100%", padding: `${PD_XLG}px ${PD_XLG2}px`, fontSize: "125%"}}>
        Start Labeling
      </Button>
    </div>
  </StyledBoxColumn>;
}
